export const GET_PROPORTION_OF_DELAYED_SAMPLES_REQUEST = `@@ddw.herdnet.sandbox.hnadvice/GET_PROPORTION_OF_DELAYED_SAMPLES_REQUEST`;
export const GET_PROPORTION_OF_DELAYED_SAMPLES_SUCCESS = `@@ddw.herdnet.sandbox.hnadvice/GET_PROPORTION_OF_DELAYED_SAMPLES_SUCCESS`;
export const GET_PROPORTION_OF_DELAYED_SAMPLES_FAILURE = `@@ddw.herdnet.sandbox.hnadvice/GET_PROPORTION_OF_DELAYED_SAMPLES_FAILURE`;

